import React from 'react';

import type { TTypes, TCheckboxSizes } from './models';

export const renderCheckMarkSVG = (type: TTypes, size: TCheckboxSizes) => {
    if (type === 'checkmark') {
        if (size === 'm') {
            return (
                <svg fill="none" height="10" width="10" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M4.066 6.333L1.5 3.908l-.825.742 3.391 3.392 5.259-5.267-.892-.817-4.367 4.375z"
                        fill="#fff"
                    />
                </svg>
            );
        }

        return (
            <svg fill="none" height="16" width="16" xmlns="http://www.w3.org/2000/svg">
                <path
                    clipRule="evenodd"
                    d="M6.35 10.543L3.207 7.661l-.887.793 4.03 3.91 7.876-7.937-.954-.871-6.922 6.987z"
                    fill="#fff"
                    fillRule="evenodd"
                />
            </svg>
        );
    }

    return <div />;
};
